import { useSelector } from 'react-redux';

import Banner from "../Layout/Banner"
import QuickLinks from "../Layout/QuickLinks"
import ListOfAppsToExplore from "../Layout/ListOfAppsToExplore";
import MidBanner from "../Layout/MidBanner";
import ThinkBeyound from "../Layout/ThinkBeyond";
import ContactUs from "../Layout/ContactUs";

const StartingPageContent = () => {

  const { currentUser } = useSelector((state) => state.user);

  return (
    <div className="grow">
      <Banner />

      {!currentUser && <QuickLinks />}

      <ListOfAppsToExplore />

      {!currentUser && <MidBanner />}

      {!currentUser && <ThinkBeyound />}

      <ContactUs />
    </div>
  );
};

export default StartingPageContent;
